import React, { Component } from 'react';
import { DropdownItem, DropdownMenu, DropdownToggle, Nav, Col, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import Badge from '@material-ui/core/Badge';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import NotificationsActiveIcon from '@material-ui/icons/NotificationsActive';
import NotificationsNoneIcon from '@material-ui/icons/NotificationsNone';
import Card from '@material-ui/core/Card';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import { AppHeaderDropdown, AppNavbarBrand, AppSidebarToggler } from '@coreui/react';
import logo from '../../assets/img/brand/logo-ideal.png';
import sygnet from '../../assets/img/brand/logo-ideal.png';
import Pusher from 'pusher-js';
import { pusher } from "../../config/config";
import { reactLocalStorage } from "reactjs-localstorage";
import { getTodayLatestLogcall, getLogCallDetail, getArchiveLogcall } from "../../services/LogCallService";
import moment from 'moment';
import newinfo from '../../assets/img/newinfo.svg';
import TabWizardComponent from '../../components/TabWizardComponent';
import { inject, observer } from 'mobx-react';
import { LSNAME } from '../../helper/constants/constants';
import { RegionOption } from '../../helper/constants/options';
import { getRegion, setRegion, setURL } from '../../helper/functions/functions';
import RegionComponent from '../../components/RegionComponent';
import { Link } from "react-router-dom";
import _ from 'lodash';

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {};
const region = getRegion();

class DefaultHeader extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showNotif: false,
      listNotification: [],
      listNotifyNotification: [],
      newNotif: 0,
      currentPage: 0,
      totalPage: 0,
      region: [RegionOption.find(value => value.value === getRegion())],
    }
  }

  componentDidMount() {

    const currentUserString = reactLocalStorage.get(LSNAME.ADMIN);
    let currentUser = JSON.parse(currentUserString)
    // if (currentUser.role === "superadmin") {
    const pusherClient = new Pusher(pusher.key, {
      cluster: pusher.cluster,
      // encrypted: true
    });
    const channel = pusherClient.subscribe(pusher.channel);
    channel.bind(`logcall${currentUser._id}`, data => {
      this.loadLogCalls();
    });
    this.loadLogCalls();
    // }
  }

  loadLogCalls = async () => {
    const currentUserString = reactLocalStorage.get(LSNAME.ADMIN);
    let currentUser = JSON.parse(currentUserString)
    try {
      const { data, error } = await getTodayLatestLogcall();
      const notifyLogcall = await getArchiveLogcall("", currentUser._id, true);
      let notifyerror = notifyLogcall.error;
      let notify = notifyLogcall.data;
      if (error) { throw error; }
      if (notifyerror) { throw notifyerror; }
      if (data || notify) {
        this.setState({
          listNotification: data.logcalls,
          listNotifyNotification: notify.archivedLogcall,
          newNotif: data.newData,
          currentPage: data.page,
          totalPage: data.totalPage
        })
      }
    } catch (e) {
      console.log(e)
    }
  }

  loadMore = async (page) => {
    try {
      const { data, error } = await getTodayLatestLogcall(page + 1);
      if (error) { throw error; }
      if (data) {
        let listdata = this.state.listNotification
        listdata.concat(data.logcalls)
        this.setState({
          listNotification: this.state.listNotification.concat(data.logcalls),
          newNotif: data.newData,
          currentPage: data.page,
          totalPage: data.totalPage
        })
      }
    } catch (e) {
      console.log(e)
    }
  }

  logout = async () => {
    this.props.authStore.signOut();
  }

  gotoEditProfile = () => {
    this.props.history.push(setURL(`editprofile`, this.state.region[0].value));
  }

  toggleNotif = event => {
    this.setState((state) => ({
      showNotif: !state.showNotif,
    }), () => {
      this.loadLogCalls();
    });
  }

  gotoNotification = async id => {
    let { data } = await getLogCallDetail(id);
    if (data) {
      this.loadLogCalls();
    }
    // window.open(setURL(`log-calls/edit/${id}`, region));
  }

  handleSelect = event => {
    let value = event[0];
    if (value.value !== this.state.region[0].value) {
      // const confirm = window.confirm('Are u sure?');
      const confirm = true;
      if (confirm) {
        setRegion(value.value);
        let url = '';
        // check region
        let pathContains = false
        for (let i = 0; i < RegionOption.length; i ++) {
          if (window.location.pathname.includes(RegionOption[i].path)) { pathContains = true; break; }
        }
        if (pathContains) {
          url = window.location.pathname.slice(4);
        } else{
          url = window.location.pathname.slice(1)
        } 
        let checkUrl = url.split('/')
        if (checkUrl.length > 0) {
          url = checkUrl[0]
          if (url === "merchants"
          || url === "brands" 
          || url === "products"
          || url === "categories"
          || url === "marketings"
          || url === "smsserver"
          || url === "reports") {
            if (checkUrl.length > 1) { 
              url = `${checkUrl[0]}/${checkUrl[1]}`
              if(checkUrl[1]==="sale"){
                url += `/${checkUrl[2]}`
              }
            }
          }
        }
        if (pathContains) {
          window.location.href = `/${value.value}/${url}`;
        } else{
          window.location.href = `/${url}`;
        } 
      }
    }
  }

  render() {
    // eslint-disable-next-line
    const { children, ...attributes } = this.props;
    const currentUser = this.props.authStore.currentUser;
    let username = 'admin@admin.com';
    if (currentUser) {
      username = currentUser.username
    }
    let listRegionOption = RegionOption;
    let ls = reactLocalStorage.getObject(LSNAME.LIST_REGION);
    if (!_.isEmpty(ls) && ls !== 'undefined') {
      listRegionOption = ls.map(l => RegionOption.find(ro => ro.value === l));
    }
    const tabNotificationArray = [
      {
        title: 'Assigned Logcall',
        badge: this.state.newNotif,
        content:
          <div style={{
            position: 'relative', minHeight: 100, maxHeight: 500, overflowY: 'auto'
          }}>
            {
              this.state.listNotification.length > 0 ? (
                <List style={{ backgroundColor: 'transparent' }}>
                  {
                    this.state.listNotification.map((value, index) => {
                      return (
                        <ListItem key={index} button onClick={(e) => this.gotoNotification(value._id)}>
                          <Card style={{
                            width: '100%', padding: 10,
                            boxShadow: !value.adminChecked ? "0 8px 40px -12px rgba(0,0,0,0.3)" : ""
                          }}>
                            <Link to={setURL(`log-calls/edit/${value._id}`, region)} style={{ textDecoration: 'none', color: '#2F2F2F' }} className="link-target">
                              <Col xs="12" md="12">
                                <Row>
                                  <Col>
                                    <div style={{ fontSize: "10px", color: 'grey' }}>{moment(value.createdDate).format("DD/MM/YYYY HH:mm")}</div>
                                  </Col>
                                  <Col style={{ textAlign: 'right' }}>
                                    <div style={{ fontSize: "10px", color: 'grey' }}>{
                                      !value.adminChecked ? (<img src={newinfo} width={20} height={20} alt="" />) : ""
                                    }</div>
                                  </Col>
                                </Row>
                                <div style={{ marginTop: 5 }}>{value.createdBy.name} assign you a logcall</div>
                                <hr style={{ marginTop: 10, marginBottom: 10 }} />
                                <Row style={{ fontSize: "12px" }}>
                                  <Col xs="6" md="4">Caller's Phone</Col>
                                  <Col>: {value.phoneNumber}</Col>
                                </Row>
                                <Row style={{ fontSize: "12px" }}>
                                  <Col xs="6" md="4">Caller's Name</Col>
                                  <Col>: {value.callerName}</Col>
                                </Row>
                                <div style={{ fontSize: "12px", marginTop: 5 }}>Description</div>
                                <Tooltip title={value.description ? value.description : "no description"}>
                                  <div style={{
                                    fontSize: "12px",
                                    lineHeight: '1.5em',
                                    height: '3em',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                  }}>{value.description ? value.description : "no description"}</div>
                                </Tooltip>
                              </Col>
                            </Link>
                          </Card>
                        </ListItem>
                      )
                    })
                  }
                  {
                    (this.state.totalPage > 1 && this.state.currentPage !== this.state.totalPage) &&
                    <div style={{ cursor: "pointer", textAlign: 'center' }} onClick={(e) => this.loadMore(this.state.currentPage)}>Load More ..</div>
                  }
                </List>
              ) : (
                <div style={{
                  width: '100%', height: '100%',
                  alignItems: 'center',
                  textAlign: 'center'
                }}>
                  <div style={{
                    marginTop: 10
                  }}>
                    <NotificationsNoneIcon className="fc-red" style={{ width: 50, height: 50 }} />
                    <div>
                      Tidak ada Notifikasi Logcall
                    </div>
                  </div>
                </div>
              )
            }
          </div>
      },
      {
        title: 'Notify Logcall',
        badge: this.state.listNotifyNotification.length,
        content:
          <div style={{
            position: 'relative', minHeight: 100, maxHeight: 500, overflowY: 'auto'
          }}>
            {
              this.state.listNotifyNotification.length > 0 ? (
                <List style={{ backgroundColor: 'transparent' }}>
                  {
                    this.state.listNotifyNotification.map((value, index) => {
                      return (
                        <ListItem key={index} button onClick={(e) => this.gotoNotification(value.logcall._id)}>
                          <Card style={{
                            width: '100%', padding: 10,
                            boxShadow: !value.logcall.adminChecked ? "0 8px 40px -12px rgba(0,0,0,0.3)" : ""
                          }}>
                            <Link to={setURL(`log-calls/edit/${value.logcall._id}`, region)} style={{ textDecoration: 'none', color: '#2F2F2F' }} className="link-target">
                              <Col xs="12" md="12">
                                <Row>
                                  {/* <Col>
                                          <div style={{fontSize: "10px", color: 'grey'}}>{moment(value.logcall.createdDate).format("DD/MM/YYYY HH:mm")}</div>
                                        </Col> */}
                                  {/* <Col style={{textAlign: 'right'}}>
                                          <div style={{fontSize: "10px", color: 'grey'}}>{
                                            !value.logcall.adminChecked ? (<img src={newinfo} width={20} height={20}/>) : ""
                                          }</div>
                                        </Col> */}
                                </Row>
                                <div style={{ marginTop: 5 }}>Logcall Reminder</div>
                                <div style={{ marginTop: 5 }}>{moment(value.notifyDate).format("DD/MM/YYYY")}</div>
                                <hr style={{ marginTop: 10, marginBottom: 10 }} />
                                <Row style={{ fontSize: "12px" }}>
                                  <Col xs="6" md="4">Caller's Phone</Col>
                                  <Col>: {value.logcall.phoneNumber}</Col>
                                </Row>
                                <Row style={{ fontSize: "12px" }}>
                                  <Col xs="6" md="4">Caller's Name</Col>
                                  <Col>: {value.logcall.callerName}</Col>
                                </Row>
                                <div style={{ fontSize: "12px", marginTop: 5 }}>Description</div>
                                <Tooltip title={value.logcall.description ? value.logcall.description : "no description"}>
                                  <div style={{
                                    fontSize: "12px",
                                    lineHeight: '1.5em',
                                    height: '3em',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                  }}>{value.logcall.description ? value.logcall.description : "no description"}</div>
                                </Tooltip>
                              </Col>
                            </Link>
                          </Card>
                        </ListItem>
                      )
                    })
                  }
                  {
                    (this.state.totalPage > 1 && this.state.currentPage !== this.state.totalPage) &&
                    <div style={{ cursor: "pointer", textAlign: 'center' }} onClick={(e) => this.loadMore(this.state.currentPage)}>Load More ..</div>
                  }
                </List>
              ) : (
                <div style={{
                  width: '100%', height: '100%',
                  alignItems: 'center',
                  textAlign: 'center'
                }}>
                  <div style={{
                    marginTop: 10
                  }}>
                    <NotificationsNoneIcon className="fc-red" style={{ width: 50, height: 50 }} />
                    <div>
                      Tidak ada Notifikasi Logcall
                    </div>
                  </div>
                </div>
              )
            }
          </div>
      }
    ]
    return (
      <React.Fragment>
        <AppSidebarToggler className="d-lg-none" display="md" mobile />
        <AppSidebarToggler className="d-md-down-none" display="lg" />
        {window.innerWidth > 600 && (
          <AppNavbarBrand
            full={{ src: logo, width: 110, height: 35, alt: 'IDeal Logo' }}
            minimized={{ src: sygnet, width: 80, height: 30, alt: 'IDeal Logo' }}
          />
        )}
        {/* <div style={{minWidth: '150px'}}>
          <ReactSelectComponent
            name={"region"}
            placeholder={"Select Region"}
            value={this.state.region}
            options={listRegion}
            onChange={this.handleSelect}
          />
        </div> */}
        <div className="ml-2">
          <RegionComponent
            value={this.state.region}
            onChange={this.handleSelect}
            options={listRegionOption}
            isMulti={false}
          />
        </div>
        {/* <Nav className="d-md-down-none" navbar>
          <NavItem className="px-3">
            <NavLink href="/">Dashboard</NavLink>
          </NavItem>
          <NavItem className="px-3">
            <NavLink href="#/users">Users</NavLink>
          </NavItem>
          <NavItem className="px-3">
            <NavLink href="#">Settings</NavLink>
          </NavItem>
        </Nav> */}
        <Nav className="ml-auto" navbar>
          {/* <NavItem className="d-md-down-none">
            <NavLink href="#"><i className="icon-bell"></i><Badge pill color="danger">5</Badge></NavLink>
          </NavItem>
          <NavItem className="d-md-down-none">
            <NavLink href="#"><i className="icon-list"></i></NavLink>
          </NavItem>
          <NavItem className="d-md-down-none">
            <NavLink href="#"><i className="icon-location-pin"></i></NavLink>
          </NavItem> */}
          {/* {(currentUser && currentUser.role === "superadmin") && */}
          <div style={{ position: 'relative' }}>
            <Tooltip title="Logcall Notification">
              <IconButton className="mr-1" onClick={this.toggleNotif}>
                <Badge badgeContent={this.state.listNotifyNotification.length > 0 ? this.state.listNotifyNotification.length : this.state.newNotif} color="primary">
                  <NotificationsActiveIcon className="fc-white" />
                </Badge>
              </IconButton>
            </Tooltip>
            {this.state.showNotif && (
              <Card elevation={3} style={{
                position: 'absolute', top: 45, right: 0, width: (window.innerWidth < 500) ? 320 : 420,
                minHeight: 100, maxHeight: 600, overflowY: 'hidden'
              }}>
                <TabWizardComponent paper={true} tabDataArray={tabNotificationArray} />
              </Card>
            )}
          </div>
          {/* } */}
          <AppHeaderDropdown className="sm-min-width-0" direction="down">
            <DropdownToggle nav className="text-right d-md-flex">
              {/* <img src={noImage} className="img-avatar sm-img-avatar" alt={email} /> */}
              <label className="d-sm-down-none m-md-auto cursor-point fc-white">{username}&nbsp;</label>
              <span className="fa fa-user btn-icon-user"></span>
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem onClick={() => this.gotoEditProfile()}><i className="fa fa-user"></i> Profile</DropdownItem>
              <DropdownItem onClick={this.logout}><i className="fa fa-lock"></i> Logout</DropdownItem>
            </DropdownMenu>
          </AppHeaderDropdown>
        </Nav>
        {/* <AppAsideToggler className="d-md-down-none" /> */}
        {/*<AppAsideToggler className="d-lg-none" mobile />*/}
      </React.Fragment>
    );
  }
}

DefaultHeader.propTypes = propTypes;
DefaultHeader.defaultProps = defaultProps;

export default inject('authStore')(observer(DefaultHeader));
